<template>
  <div class="pointer-events-none fixed right-4 top-4 z-[9999] flex w-[320px] max-w-[calc(100vw-2rem)] flex-col gap-2">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="pointer-events-auto rounded-lg border px-3 py-2 text-sm font-medium shadow-lg"
      :class="toastClass(toast.type)"
    >
      <div class="flex items-start justify-between gap-2">
        <p class="leading-5">
          {{ toast.message }}
        </p>
        <button
          class="text-xs opacity-75 hover:opacity-100"
          type="button"
          @click="removeToast(toast.id)"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {ToastType, useToast} from '@/composables/useToast';

export default defineComponent({
  name: 'AppToastStack',
  setup() {
    const {toasts, removeToast} = useToast();

    const toastClass = (type: ToastType): string => {
      if (type === 'success') {
        return 'border-green-200 bg-green-50 text-green-700';
      }
      if (type === 'error') {
        return 'border-red-200 bg-red-50 text-red-700';
      }
      return 'border-gray-200 bg-white text-gray-700';
    };

    return {
      toasts,
      removeToast,
      toastClass,
    };
  },
});
</script>

